<div class="gdrp-popup" *ngIf="gdrpIsShow">
  <div class="text" [innerHTML]="'gdrp-text' | translate"></div>
  <button class="bm-button bordered" (click)="gotIt()">
    {{ 'got-it' | translate }}
  </button>
</div>
